/* eslint-disable no-undef */
import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { StyledModal } from "../AttendeesModal/styles";
import { Border } from "../Journeys/styles";
import ReactPlayer from "react-player";
import { AdminCloseIcon } from "../../utils/icons";
import { CustomTitle } from "./styles";

const VideoModal = ({ showModal, onHide, t, videoLink, title }) => {

  window.console.log("hii")

  const playerRef = useRef(null);
  const [videoSize, setVideoSize] = useState({ width: 800, height: 450 }); // default size

  const handleVideoReady = () => {
    const internalPlayer = playerRef.current?.getInternalPlayer();
    window.console.log("internalPlayer",internalPlayer)
    if (internalPlayer) {
      const width = internalPlayer.element.clientWidth;
      const height = internalPlayer.element.clientHeight;
      if (width && height) {
        setVideoSize({ width, height });
      }
    }
  };

  return (
    <StyledModal $width={videoSize?.width+"px"} $height={(videoSize?.height + 32) +"px"} show={showModal} onHide={onHide}>
      {/* Header */}
      <Modal.Header style={{ background: "white", border: "none" }}>
        <CustomTitle>
          <div className="headerContainer">
            <span className="title">{t(title)}</span>
            <span className="closeImage">
              <div onClick={onHide}>{AdminCloseIcon()}</div>
            </span>
          </div>
        </CustomTitle>
      </Modal.Header>

      <Border
        style={{
          width: "96%",
          background: "#EFEFEF",
          margin: "0px 18px 10px",
        }}
      />

      {/* Body */}
      <Modal.Body
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4px",
          padding:'24px',
          overflow:'hidden'
        }}
      >
        <ReactPlayer
          className="react-player"
          url={videoLink}
          ref={playerRef}
          // onEnded={this.props.updateUserPoints}
          height={videoSize?.height}
          width={videoSize?.width}
          controls
          key={videoLink}
          onReady={handleVideoReady}
        />
      </Modal.Body>


    </StyledModal>
  );
};

VideoModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  videoLink:PropTypes.string,
  title:PropTypes.string,
};

export default withTranslation()(VideoModal);



